import { useState } from 'react';
import Swal from 'sweetalert2';
import baseURL from '../url';

const ConfigURL = () => {
    const [url, setUrl] = useState(localStorage.getItem('baseURL') || '');

    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subCategorias, setSubCategorias] = useState([]);
    const [banners, setBanners] = useState([]);
    const [tiendas, setTiendas] = useState([]);
    const [tiendas2, setTiendas2] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    const [servicios, setServicios] = useState([]);
    const [eliminandoServicios, setEliminandoServicios] = useState(false);

    const [eliminandoPedidos, setEliminandoPedidos] = useState(false);

    const [eliminandoTiendas, setEliminandoTiendas] = useState(false);

    const [eliminandoTiendas2, setEliminandoTiendas2] = useState(false);

    const [eliminando, setEliminando] = useState(false);

    // ================= URL =================
    const handleSave = () => {
        if (!url.startsWith('http')) {
            alert('La URL debe empezar con http o https');
            return;
        }
        localStorage.setItem('baseURL', url);
        window.location.reload();
    };

    // ================= PRODUCTOS =================
    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => setProductos(data.productos || []))
            .catch(err => console.error(err));
    };

    const eliminarProducto = (idProducto) =>
        fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
            method: 'DELETE',
        }).then(res => res.json());

    const eliminarTodosProductos = async () => {
        if (!productos.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todos los productos?',
            text: `Se eliminarán ${productos.length} productos`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
        });

        if (!confirm.isConfirmed) return;

        setEliminando(true);
        Swal.fire({ title: 'Eliminando productos...', didOpen: () => Swal.showLoading() });

        for (let i = 0; i < productos.length; i++) {
            await eliminarProducto(productos[i].idProducto);
            Swal.update({ html: `Eliminados ${i + 1} de ${productos.length}` });
        }

        setProductos([]);
        setEliminando(false);
        Swal.fire('Finalizado', 'Productos eliminados', 'success');
    };

    // ================= CATEGORÍAS =================
    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => {
                const ordenadas = (data.categorias || []).sort((a, b) => a.orden - b.orden);
                setCategorias(ordenadas);
            })
            .catch(err => console.error(err));
    };

    const eliminarCategoria = (idCategoria) =>
        fetch(`${baseURL}/categoriaDelete.php?idCategoria=${idCategoria}`, {
            method: 'DELETE',
        }).then(res => res.json());

    const eliminarTodasCategorias = async () => {
        if (!categorias.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todas las categorías?',
            text: `Se eliminarán ${categorias.length} categorías`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
        });

        if (!confirm.isConfirmed) return;

        setEliminando(true);
        Swal.fire({ title: 'Eliminando categorías...', didOpen: () => Swal.showLoading() });

        for (let i = 0; i < categorias.length; i++) {
            await eliminarCategoria(categorias[i].idCategoria);
            Swal.update({ html: `Eliminadas ${i + 1} de ${categorias.length}` });
        }

        setCategorias([]);
        setEliminando(false);
        Swal.fire('Finalizado', 'Categorías eliminadas', 'success');
    };

    // ================= SUBCATEGORÍAS =================
    const cargarSubCategorias = () => {
        fetch(`${baseURL}/subCategoriaGet.php`)
            .then(res => res.json())
            .then(data => setSubCategorias(data.subcategorias || []))
            .catch(err => console.error(err));
    };

    const eliminarSubCategoria = (idSubCategoria) =>
        fetch(`${baseURL}/subCategoriaDelete.php?idSubCategoria=${idSubCategoria}`, {
            method: 'DELETE',
        }).then(res => res.json());

    const eliminarTodasSubCategorias = async () => {
        if (!subCategorias.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todas las subcategorías?',
            text: `Se eliminarán ${subCategorias.length} subcategorías`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
        });

        if (!confirm.isConfirmed) return;

        setEliminando(true);
        Swal.fire({ title: 'Eliminando subcategorías...', didOpen: () => Swal.showLoading() });

        for (let i = 0; i < subCategorias.length; i++) {
            await eliminarSubCategoria(subCategorias[i].idSubCategoria);
            Swal.update({ html: `Eliminadas ${i + 1} de ${subCategorias.length}` });
        }

        setSubCategorias([]);
        setEliminando(false);
        Swal.fire('Finalizado', 'Subcategorías eliminadas', 'success');
    };

    // ================= BANNERS =================
    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`)
            .then(res => res.json())
            .then(data => setBanners(data.banner || []))
            .catch(err => console.error(err));
    };

    const eliminarBanner = (idBanner) =>
        fetch(`${baseURL}/bannerDelete.php?idBanner=${idBanner}`, {
            method: 'DELETE',
        }).then(res => res.json());

    const eliminarTodosBanners = async () => {
        if (!banners.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todos los banners?',
            text: `Se eliminarán ${banners.length} banners`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
        });

        if (!confirm.isConfirmed) return;

        setEliminando(true);
        Swal.fire({ title: 'Eliminando banners...', didOpen: () => Swal.showLoading() });

        for (let i = 0; i < banners.length; i++) {
            await eliminarBanner(banners[i].idBanner);
            Swal.update({ html: `Eliminados ${i + 1} de ${banners.length}` });
        }

        setBanners([]);
        setEliminando(false);
        Swal.fire('Finalizado', 'Banners eliminados', 'success');
    };
    // =============================
    // TIENDAS (TODAS)
    // =============================
    const cargarTiendas = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(res => res.json())
            .then(data => setTiendas(data.tienda || []))
            .catch(err => console.error(err));
    };

    const eliminarTienda = (idTienda) => {
        return fetch(`${baseURL}/tiendaDelete.php?idTienda=${idTienda}`, {
            method: 'DELETE',
        }).then(res => res.json());
    };

    const eliminarTodasTiendas = async () => {
        if (!tiendas.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todas las tiendas?',
            text: `Se eliminarán ${tiendas.length} tiendas`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return;

        setEliminandoTiendas(true);
        Swal.fire({ title: 'Eliminando tiendas...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

        for (let i = 0; i < tiendas.length; i++) {
            await eliminarTienda(tiendas[i].idTienda);
            Swal.update({ html: `Eliminadas ${i + 1} de ${tiendas.length}` });
        }

        setTiendas([]);
        setEliminandoTiendas(false);

        Swal.fire('Proceso finalizado', 'Todas las tiendas fueron eliminadas', 'success');
    };


    // =============================
    // TIENDAS2 (TODAS)
    // =============================
    const cargarTiendas2 = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(res => res.json())
            .then(data => setTiendas2(data.tiendas || []))
            .catch(err => console.error('Error al cargar tiendas:', err));
    };

    const eliminarTienda2 = (idTienda) => {
        return fetch(`${baseURL}/tiendaDelete.php?idTienda=${idTienda}`, {
            method: 'DELETE',
        }).then(res => res.json());
    };
    const eliminarTodasTiendas2 = async () => {
        if (!tiendas2.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todas las tiendas?',
            text: `Se eliminarán ${tiendas2.length} tiendas`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return;

        setEliminandoTiendas2(true);

        Swal.fire({
            title: 'Eliminando tiendas...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        for (let i = 0; i < tiendas2.length; i++) {
            try {
                await eliminarTienda2(tiendas2[i].idTienda);
            } catch (e) {
                console.error('Error eliminando tienda', tiendas2[i].idTienda);
            }


            Swal.update({
                html: `Eliminadas ${i + 1} de ${tiendas2.length}`,
            });
        }


        setTiendas2([]);
        setEliminandoTiendas2(false);

        Swal.fire(
            'Proceso finalizado',
            'Todas las tiendas fueron eliminadas',
            'success'
        );
    };


    // =============================
    // PEDIDOS (TODOS)
    // =============================
    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`)
            .then(res => res.json())
            .then(data => setPedidos((data.pedidos || []).reverse()))
            .catch(err => console.error('Error al cargar pedidos:', err));
    };
    const eliminarPedido = (idPedido) => {
        return fetch(`${baseURL}/pedidoDelete.php?idPedido=${idPedido}`, {
            method: 'DELETE',
        }).then(res => res.json());
    };

    const eliminarTodosPedidos = async () => {
        if (!pedidos.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todos los pedidos?',
            text: `Se eliminarán ${pedidos.length} pedidos`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return;

        setEliminandoPedidos(true);

        Swal.fire({
            title: 'Eliminando pedidos...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        for (let i = 0; i < pedidos.length; i++) {
            await eliminarPedido(pedidos[i].idPedido);

            Swal.update({
                html: `Eliminados ${i + 1} de ${pedidos.length}`,
            });
        }

        setPedidos([]);
        setEliminandoPedidos(false);

        Swal.fire(
            'Proceso finalizado',
            'Todos los pedidos fueron eliminados',
            'success'
        );
    };

    // ================= SERVICIOS =================
    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`)
            .then(res => res.json())
            .then(data => setServicios(data.servicios || []))
            .catch(err => console.error('Error al cargar servicios:', err));
    };
    const eliminarServicio = (idServicio) => {
        return fetch(`${baseURL}/servicioDelete.php?idServicio=${idServicio}`)
            .then(res => res.json());
    };
    const eliminarTodosServicios = async () => {
        if (!servicios.length) return;

        const confirm = await Swal.fire({
            title: '¿Eliminar todos los servicios?',
            text: `Se eliminarán ${servicios.length} servicios`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });

        if (!confirm.isConfirmed) return;

        setEliminandoServicios(true);

        Swal.fire({
            title: 'Eliminando servicios...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        for (let i = 0; i < servicios.length; i++) {
            try {
                await eliminarServicio(servicios[i].idServicio);

                Swal.update({
                    html: `Eliminados ${i + 1} de ${servicios.length}`,
                });
            } catch (e) {
                console.error('Error eliminando servicio:', servicios[i].idServicio);
            }
        }

        setServicios([]);
        setEliminandoServicios(false);

        Swal.fire(
            'Proceso finalizado',
            'Todos los servicios fueron eliminados',
            'success'
        );
    };

    return (
        <div style={styles.wrapper}>
            {/* URL */}
            <div style={styles.inputGroup}>
                <input
                    type="text"
                    placeholder="https://dominio.com"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    style={styles.input}
                />
                <button onClick={handleSave} style={styles.button}>OK</button>
            </div>

            {/* PRODUCTOS */}
            <div style={styles.row}>
                <button onClick={cargarProductos} style={styles.secondaryBtn}>Cargar productos</button>
                <button onClick={eliminarTodosProductos} style={styles.dangerBtn}>Eliminar {productos.length}</button>
            </div>

            {/* CATEGORÍAS */}
            <div style={styles.row}>
                <button onClick={cargarCategorias} style={styles.secondaryBtn}>Cargar categorías</button>
                <button onClick={eliminarTodasCategorias} style={styles.dangerBtn}>Eliminar {categorias.length}</button>
            </div>

            {/* SUBCATEGORÍAS */}
            <div style={styles.row}>
                <button onClick={cargarSubCategorias} style={styles.secondaryBtn}>Cargar subcategorías</button>
                <button onClick={eliminarTodasSubCategorias} style={styles.dangerBtn}>Eliminar {subCategorias.length}</button>
            </div>

            {/* BANNERS */}
            <div style={styles.row}>
                <button onClick={cargarBanners} style={styles.secondaryBtn}>Cargar banners</button>
                <button onClick={eliminarTodosBanners} style={styles.dangerBtn}>Eliminar  {banners.length}</button>
            </div>


            <div style={styles.row}>
                <button onClick={cargarTiendas} style={styles.secondaryBtn}>Cargar tiendas</button>
                <button onClick={eliminarTodasTiendas} style={styles.dangerBtn} disabled={!tiendas.length || eliminandoTiendas}>
                    Eliminar  {tiendas.length}
                </button>
            </div>
            <div style={styles.row}>
                <button onClick={cargarPedidos} style={styles.secondaryBtn}>
                    Cargar pedidos
                </button>

                <button
                    onClick={eliminarTodosPedidos}
                    style={styles.dangerBtn}
                    disabled={!pedidos.length || eliminandoPedidos}
                >
                    Eliminar  {pedidos.length}
                </button>
            </div>

            <div style={styles.row}>
                <button onClick={cargarTiendas2} style={styles.secondaryBtn}>
                    Cargar tiendas2
                </button>

                <button
                    onClick={eliminarTodasTiendas2}
                    style={styles.dangerBtn}
                    disabled={!tiendas2.length || eliminandoTiendas2}
                >
                    Eliminar  {tiendas2.length}
                </button>
            </div>
            <div style={styles.row}>
                <button onClick={cargarServicios} style={styles.secondaryBtn}>
                    Cargar servicios
                </button>

                <button
                    onClick={eliminarTodosServicios}
                    style={styles.dangerBtn}
                    disabled={!servicios.length || eliminandoServicios}
                >
                    Eliminar servicios ({servicios.length})
                </button>
            </div>


        </div>
    );
};

const styles = {
    wrapper: {
        padding: '10px',
        borderRadius: '12px',
        background: '#fff',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        fontFamily: 'system-ui',
    },
    inputGroup: { display: 'flex', gap: '10px' },
    row: { display: 'flex', gap: '10px', marginTop: '10px' },
    input: {
        flex: 1,
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
    },
    button: {
        background: '#2563eb',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        padding: '10px 16px',
        cursor: 'pointer',
    },
    secondaryBtn: {
        flex: 1,
        padding: '10px',
        borderRadius: '8px',
        border: '1px solid #d1d5db',
        background: '#f9fafb',
        cursor: 'pointer',
    },
    dangerBtn: {
        flex: 1,
        padding: '10px',
        borderRadius: '8px',
        border: 'none',
        background: '#dc2626',
        color: '#fff',
        fontWeight: 600,
        cursor: 'pointer',
    },
    helper: {
        fontSize: '12px',
        color: '#6b7280',
        textAlign: 'center',
    },
};

export default ConfigURL;
